import React from "react";
import { BookOpen, Scale } from "lucide-react";

export default function KusurRehberPanel({ sabitler }) {
    if (!sabitler) {
        return (
            <div className="rounded-xl border border-white/10 bg-[#121A2F]/40 p-6 text-sm text-slate-500">
                Rehber yükleniyor…
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="rounded-xl border border-[#a31d21]/25 bg-[#a31d21]/5 p-4">
                <div className="flex items-center gap-2 text-[#a31d21] mb-2">
                    <Scale className="h-5 w-5" />
                    <h2 className="font-medium text-white">KTK m.84 — Asli Kusur</h2>
                </div>
                <p className="text-[11px] text-slate-400 mb-3">
                    Tutanakta işaretlenen ihlaller ve tipik kusur aralıkları. Analiz motoru bu çerçeveyi kullanır.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
                    {(sabitler.ktk_84 || []).map((k) => (
                        <div key={k.kod} className="rounded-lg border border-white/10 bg-[#0B1220]/60 p-3">
                            <div className="text-xs font-medium text-white">{k.baslik}</div>
                            <div className="text-[10px] text-[#a31d21] mt-1">Tipik: %{k.tipik_oran}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="rounded-xl border border-white/10 bg-[#121A2F]/40 p-4">
                <div className="flex items-center gap-2 mb-3">
                    <BookOpen className="h-4 w-4 text-sky-400" />
                    <h3 className="text-sm font-medium text-white">Değerlendirme Boyutları</h3>
                </div>
                <div className="grid sm:grid-cols-2 gap-2">
                    {(sabitler.degerlendirme_boyutlari || []).map((d) => (
                        <div key={d.id} className="rounded-lg border border-white/10 p-3">
                            <div className="text-xs text-white font-medium">{d.label}</div>
                            <p className="text-[10px] text-slate-500 mt-1">{d.aciklama}</p>
                        </div>
                    ))}
                </div>
            </div>

            {sabitler.kusur_degisim_rehberi?.length ? (
                <div className="rounded-xl border border-violet-500/25 bg-violet-500/5 p-4">
                    <h3 className="text-sm font-medium text-violet-200 mb-2">Kusur Değişim Rehberi</h3>
                    <div className="space-y-2">
                        {sabitler.kusur_degisim_rehberi.map((item, i) => (
                            <div key={i} className="rounded-lg border border-white/10 bg-[#0B1220]/40 p-3 text-[11px]">
                                <div className="font-medium text-white">{item.oran}</div>
                                {item.ne_zaman ? (
                                    <p className="text-slate-400 mt-1">{item.ne_zaman}</p>
                                ) : null}
                                {item.degisir_mi ? (
                                    <p className="text-emerald-400/90 mt-1">
                                        <span className="text-slate-500">Değişir:</span> {item.degisir_mi}
                                    </p>
                                ) : null}
                                {item.degismezse ? (
                                    <p className="text-slate-500 mt-0.5">
                                        <span className="text-slate-600">Değişmezse:</span> {item.degismezse}
                                    </p>
                                ) : null}
                            </div>
                        ))}
                    </div>
                </div>
            ) : null}

            {sabitler.itiraz_hatirlatma ? (
                <div className="rounded-lg border border-amber-500/20 bg-amber-500/5 p-3 text-[11px] text-amber-100/90 leading-relaxed">
                    {sabitler.itiraz_hatirlatma}
                </div>
            ) : null}

            <div className="rounded-lg border border-white/10 p-3">
                <div className="text-[10px] uppercase text-slate-500 mb-2">Geçerli Kusur Oranları</div>
                <div className="flex flex-wrap gap-1.5">
                    {(sabitler.kusur_oranlari || [0, 25, 50, 75, 100]).map((o) => (
                        <span
                            key={o}
                            className="px-2 py-0.5 rounded border border-white/10 text-xs font-mono text-slate-300"
                        >
                            %{o}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
